import React from 'react';

// Full-screen WOW loader. `overlay` keeps the app behind visible (used during
// network switch / tx) so nothing ever feels like a hard refresh.
export default function Loader({ text = 'Evitta', sub = '', overlay = false }) {
  return (
    <div className={`loader-screen ${overlay ? 'overlay' : ''}`}>
      <div className="loader-core">
        <div className="orbit o1" />
        <div className="orbit o2" />
        <div className="orbit o3" />
        <div className="node" />
        <div className="node blue" />
        <div className="loader-hex">
          <span>E</span>
        </div>
      </div>
      <div className="loader-text gold-text">{text}</div>
      <div className="loader-sub">
        {sub || (
          <span className="loader-dots">
            Loading<span>.</span><span>.</span><span>.</span>
          </span>
        )}
      </div>
    </div>
  );
}
